function createDynamicTheme(atheme) {
  const colors = atheme.colors
  const theme = {
    dark: false,
    headerLogo: atheme.headerLogo,
    colorLogo: atheme.colorLogo,
    colors: {
      primary: colors.primary || '#FDB714',
      secondary: colors.secondary || '#FFF4DC',
      textColor: colors.textColor || '#000000',
      primaryButtonTextColor: colors.primaryButtonTextColor || '#FFFFFF',
      normalButtonBackground: colors.normalButtonBackground || '#f5f5f5',
      normalButtonTextColor: colors.normalButtonTextColor || '#4A4A4A',
      success: {
        base: colors.success?.base || '#64C636',
        lighten1: colors.success?.lighten1 || '#E7FFD9',
        darken1: colors.success?.darken1 || '#36C658'
      },
      error: colors.error || '#FF7C7C',
      headerBackground: colors.headerBackground || '#272727',
      headerTextColor: colors.headerTextColor || '#FFFFFF',
      cardBackground: colors.cardBackground || '#FFFFFF',
      cardText: colors.cardText || '#9e9e9e',
      datatableBackground: colors.datatableBackground || '#FFFFFF',
      datatableTextColor: colors.datatableTextColor || '#000000',
      datatableHighlightBackground: colors.datatableHighlightBackground || '#eeeeee',
      accent: colors.accent || '#82b1ff',
      grey: colors.grey || '#9e9e9e',
      statusEnabled: colors.statusEnabled || '#e7ffd9',
      statusEnabledTextColor: colors.statusEnabledTextColor || '#64c636',
      statusInactive: colors.statusInactive || '#d1e8ff',
      statusInactiveTextColor: colors.statusInactiveTextColor || '#007afe',
      navbarBackground: colors.navbarBackground || '#FFFFFF',
      navbarTextColor: colors.navbarTextColor || '#000000',
      navbarActiveTextColor: colors.navbarActiveTextColor || '#FDB714',
      navbarIconBackground: colors.navbarIconBackground || '#FFF4DC',
      navbarActiveIcon: colors.navbarActiveIcon || '#FFFFFF',
      navbarActiveIconBackground: colors.navbarActiveIconBackground || '#FDB714',
      background: colors.background || '#F3F3F3',
      filterbutton: colors.filterbutton || '#FFFFFF',
      filterbuttonTextColor: colors.filterbuttonTextColor || '#000000',
      decline: colors.decline || '#FF7C7C',
      dragAndDropCardColor: colors.dragAndDropCardColor || '#f3f3f3',
      modalButtonColor: colors.modalButtonColor || '#68A9C5',
      scrollbarThumbBackgroundColor: colors.scrollbarThumbBackgroundColor || '#d6dee1',
      scrollbarThumbHoverBackgroundColor: colors.scrollbarThumbHoverBackgroundColor || '#a8bbbf'
    }
  }
  return theme
}

export default createDynamicTheme
